import { useGetStrings } from "@app/store/service/cmsService"
import { handleKeyboardSelect } from "@app/utils/accessibility"
import { classNamez } from "@tecreation/funnel-components"
import "./TimeslotButton.css"

export default function ({ time, onClick, selected, discount }) {
	const {
		data: { from },
	} = useGetStrings()
	return (
		<button
			className={"timeslotButton" + classNamez({ selected: selected, discount: discount })}
			onClick={onClick}
			aria-pressed={selected}
			onKeyDown={e => {
				handleKeyboardSelect(e, onClick)
			}}
		>
			{from} {time.substring(0, time.length - 3)}
		</button>
	)
}
